import { GridCellParams } from '@mui/x-data-grid-pro';
import { isRowInEditMode } from 'features/Orders/OrderWorkunits/helpersOrderWorkunits';
import React from 'react';
import PurchaseOrderCell from '../PurchaseOrderCell/PurchaseOrderCell';
import { useSelector } from 'store/hooks';
import { formatDateToddMMYYY } from 'helpers/format';
import { SelectedWorkunit } from 'types/entities/SelectedWorkunit';
import PurchaseOrders from 'types/entities/PurchaseOrders';

export default function OrderGridPoCell(props: { params: GridCellParams<SelectedWorkunit, any, any> }) {
  const { params } = props;
  const purchase_orders = useSelector((state) => state.purchaseOrder?.datas);

  const poList = purchase_orders
    ?.filter((item: { is_archived: boolean }) => item.is_archived === false)
    ?.map(
      (item: {
        is_valid: boolean;
        id: number;
        poref: string;
        is_archived: any;
        poend: string;
        reference: string;
        postart: string;
      }) => ({
        id: item.id,
        name: item.poref,
        is_valid: item.is_valid,
        reference: `${item.poref} (${formatDateToddMMYYY(item.postart)} - ${formatDateToddMMYYY(item.poend)})`,
      })
    );

  const filteredItem = poList?.find((item) => params?.row?.po_name?.id === item.id);

  const activeEditRowIds = useSelector((state) => state.catalogToOrder.selectedWorkunitsEditIds);
  if (isRowInEditMode(activeEditRowIds, params.row.randomId)) {
    return <PurchaseOrderCell row={params.row as SelectedWorkunit} cellType="selected" />;
  }

  return <>{filteredItem?.reference || params.row?.po_name?.name}</>;
}
